"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Dialog = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _verticalScrollBox = _interopRequireDefault(require("../vertical-scroll-box"));

var _svg = _interopRequireDefault(require("../svg"));

var _util = require("../../util");

require("./dialog.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A Modal/Dialog component.  Uses react-modal for the modal implementation.
 * This modal is controlled, so you must implement the logic for whether the modal is
 * open/closed in a wrapping component.  react-modal handles close logic and calls
 * onRequestClose when it determines the modal should close.
 *
 * This component was copied over from ecomm-front-end.
 * Conceptually, a Dialog differs from a Modal in that a Dialog has buttons.
 * Practically, our ui-common Modal implementation is very minimal and used in a few apps.
 * We should move towards this component as it has a more accessible modal implementation.
 *
 * To use this component, you must pass in a `reactRoot` prop or define `reactRoot` on the
 * window. See `../../util/react-root.jsx` for info on defining it.
 *
 * @param {Object} props - React props
 * @param {String} props.overlayClassName - Class for the overlay underneath the modal.
 * @param {String} props.className - Class applied to Modal component
 * @param {String} props.title - Title applied to top of Modal.
 * @param {Boolean} props.isOpen - Controls whether the Modal isOpen)
 * @param {Node} props.actionButtons - React node to render a row of action buttons at bottom
 * @param {Function} props.onRequestClose - Callback when react-modal decides the modal should close
 * @param {Boolean} props.withScrollBox - Includes the content inside a vertically scrolling box.
 * @param {Boolean} props.showTopRightCloseButton - Show an 'x' close button on top right.
 * @param {Boolean} props.withPadding - Give left and right padding to dialog content.
 * @param {String} props.reactRoot - This is a query selector for the id of the consuming app's
 *                                   React root element. ie '#root' or '#react'
 */
var Dialog = /*#__PURE__*/function (_React$Component) {
  _inherits(Dialog, _React$Component);

  var _super = _createSuper(Dialog);

  function Dialog(props) {
    var _this;

    _classCallCheck(this, Dialog);

    _this = _super.call(this, props);

    if (typeof window !== 'undefined') {
      var reactRoot = _this.getReactRoot(); // React Modal requires us to register the React root


      _reactModal["default"].setAppElement(document.querySelector(reactRoot));
    }

    return _this;
  } // reactRoot passed as prop takes precedence over window


  _createClass(Dialog, [{
    key: "getReactRoot",
    value: function getReactRoot() {
      var reactRoot = this.props.reactRoot;
      return reactRoot || (0, _util.getReactRoot)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          overlayClassName = _this$props.overlayClassName,
          className = _this$props.className,
          children = _this$props.children,
          title = _this$props.title,
          isOpen = _this$props.isOpen,
          actionButtons = _this$props.actionButtons,
          onRequestClose = _this$props.onRequestClose,
          withScrollBox = _this$props.withScrollBox,
          showTopRightCloseButton = _this$props.showTopRightCloseButton,
          withPadding = _this$props.withPadding;
      var content = withScrollBox ? /*#__PURE__*/_react["default"].createElement(_verticalScrollBox["default"], {
        updateKey: children
      }, children) : children;
      var header = title ? /*#__PURE__*/_react["default"].createElement("h3", {
        className: "h3"
      }, title) : null;
      var topRightCloseButton = showTopRightCloseButton ? /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "close-button-top-right",
        onClick: onRequestClose
      }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
        className: "dynamic",
        id: "close"
      })) : null;
      return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
        className: (0, _classnames["default"])('Dialog', className, {
          withPadding: withPadding,
          withScrollBox: withScrollBox
        }),
        overlayClassName: (0, _classnames["default"])('dialogOverlay', overlayClassName),
        contentLabel: title,
        isOpen: isOpen,
        onRequestClose: onRequestClose
      }, topRightCloseButton, header, content, /*#__PURE__*/_react["default"].createElement("div", {
        className: "actionButtons"
      }, actionButtons));
    }
  }]);

  return Dialog;
}(_react["default"].Component);

exports.Dialog = Dialog;
Dialog.propTypes = {
  className: _propTypes["default"].string,
  overlayClassName: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  onRequestClose: _propTypes["default"].func,
  withScrollBox: _propTypes["default"].bool,
  showTopRightCloseButton: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  actionButtons: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  withPadding: _propTypes["default"].bool,
  reactRoot: _propTypes["default"].string
};
Dialog.defaultProps = {
  className: '',
  overlayClassName: '',
  isOpen: false,
  title: '',
  onRequestClose: null,
  withScrollBox: true,
  showTopRightCloseButton: true,
  actionButtons: null,
  withPadding: false,
  reactRoot: null
};
var _default = Dialog;
exports["default"] = _default;